// Constantes partagées du data layer Tablier.
// Module sans dépendance, importable depuis tenant.ts ET migrations/* sans
// risque de cycle. Source unique de vérité pour les clés persistantes.

export const STORAGE_KEY_TENANT_ID = 'tablier:tenantId';

// Préfixe du marqueur de version du seed catalogue (D3, tech-design §3.3).
// Clé complète = `tablier:seedVersion:<tenantId>` (tenant-scopée). Ajout additif —
// aucune fonction existante touchée. Écrite APRÈS validation de la transaction seed.
export const STORAGE_KEY_SEED_VERSION_PREFIX = 'tablier:seedVersion:';
